export default "__VITE_ASSET__9lGMatJB__"